<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('rolesmanage.pageTitleText') }}
            p Manage roles.
            strong You have created {{ usage.used }} of {{ usage.max }} roles.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="roleName"
            :primarySearchKeyI18="$t('rolesmanage.roleName')"
            :withFormExamples="true"
            :formExampleComponents="'RolesManageFormExamples'"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','RolesManage')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','RolesManage')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','RolesManage')"
        )
</template>
<script>
import Vue from "vue";
import RcmTable from "@/components/RcmTable_v2";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import RolePermissionBtn from "@/components/RolesManage/RolePermissionBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("RolePermissionBtn", RolePermissionBtn);
import { getGroupAsset } from "@/api/groupasset.js";

import { settingZoneExplain } from "./fields.js";

export default {
    name: "RolesManage",
    components: { RcmTable },
    data() {
        return {
            esIndex: "rcm-rolesv2",
            drawerTitleKey: "roleName",
            assetCategory: "roles",
            usage: { used: "", max: "", available: "" },
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("rolesmanage.createText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            if (this.$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow) {
                return this.$store.getters.isAdmin
                    ? {
                          action: {},
                          settingZoneExplain: settingZoneExplain(this),
                          groupName: {},
                          roleName: {},
                          _id: {},
                          dashboardPermission: {},
                          domainManagePermission: {},
                          groupResourcesPermission: {},
                          intelligentProtectionPermission: {},
                          billingPermission: {},
                          status: {},
                          objectLog: {},
                      }
                    : {
                          action: {},
                          groupName: {},
                          settingZoneExplain: settingZoneExplain(this),
                          roleName: {},
                          dashboardPermission: {},
                          domainManagePermission: {},
                          groupResourcesPermission: {},
                          intelligentProtectionPermission: {},
                          billingPermission: {},
                          status: {},
                          objectLog: {},
                      };
            } else {
                return this.$store.getters.isAdmin
                    ? {
                          action: {},
                          settingZoneExplain: settingZoneExplain(this),
                          groupName: {},
                          roleName: {},
                          _id: {},
                          dashboardPermission: {},
                          domainManagePermission: {},
                          groupResourcesPermission: {},
                          intelligentProtectionPermission: {},
                          status: {},
                          objectLog: {},
                      }
                    : {
                          action: {},
                          groupName: {},
                          settingZoneExplain: settingZoneExplain(this),
                          roleName: {},
                          dashboardPermission: {},
                          domainManagePermission: {},
                          groupResourcesPermission: {},
                          intelligentProtectionPermission: {},
                          status: {},
                          objectLog: {},
                      };
            }
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    beforeMount() {
        if (!this.$store.getters.isAdmin) {
            let rolePermission = this.$store.state.userData.inGroupsRole.filter(
                (role) => role.groupName == this.$store.state.queryGroupName
            )[0].rolePermissions;
            for (let permission in rolePermission) {
                if (rolePermission[permission].read !== true) {
                    delete this.esIndexFields[permission];
                }
            }
        }
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/RolesManage/Page.vue